import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit {

  public dialogIsOpen = false;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  public OnSubmit(form: EventForm): void {
    if (!form.valid) {
      return;
    }

    this.router.navigate([`/${form.value.eventKey}`]);
  }

  public ShowDialog(): void {
    this.dialogIsOpen = true;
  }

  public CloseDialog(): void {
    this.dialogIsOpen = false;
  }
}

interface EventForm extends NgForm {
  value: {
    eventKey: string;
  };
}
